import React from "react";
import { styled } from "@mui/material/styles";
import { TableRow, TableCell } from "@mui/material";
import colors from "assets/theme-dark/base/colors";
import TruncatedText from "../TruncatedText";
import { AnalysisDriverType } from "../../types/types";
import { formatDriverHeader } from "../../utils/excel/createHeaders";
import { cruxyColors } from "../../theme/color-palette";

interface HeadroomTableHeaderRowProps {
  segmentsColSpan: number;
  driverType: string;
  driverNumeratorType: string;
  driverMode: AnalysisDriverType;
  driver: string;
}

const HeadroomTableHeaderRow: React.FC<HeadroomTableHeaderRowProps> = ({
  segmentsColSpan,
  driverType,
  driverNumeratorType,
  driverMode,
  driver,
}) => (
  <TableRow>
    <HeaderTableCell colSpan={segmentsColSpan} align="center">
      Segments
    </HeaderTableCell>
    <HeaderTableCell align="center"># Customers</HeaderTableCell>
    <HeaderTableCell align="center"># Prospects</HeaderTableCell>
    <HeaderTableCell align="center">Penetration (%)</HeaderTableCell>
    <HeaderTableCell colSpan={3} align="center">
      <TruncatedText
        text={formatDriverHeader(1, driverType, driverNumeratorType, driverMode, "headroom")}
        maxLength={30}
      />
    </HeaderTableCell>
    <HeaderTableCell align="center">Headroom (%)</HeaderTableCell>
    <HeaderTableCell align="center">Increased Penetration (%)</HeaderTableCell>
    <HeaderTableCell align="center">Final # Customers</HeaderTableCell>
    <HeaderTableCell align="center">
      <TruncatedText text={`Total Initial ${driver}`} maxLength={30} />
    </HeaderTableCell>
    <HeaderTableCell align="center">
      <TruncatedText text={`Total Final ${driver}`} maxLength={30} />
    </HeaderTableCell>
    <HeaderTableCell align="center">Total Headroom</HeaderTableCell>
  </TableRow>
);

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${colors.grey[300]}`,
  padding: theme.spacing(1.5),
  fontSize: "0.85rem",
  backgroundColor: cruxyColors.blue.main,
  color: colors.white.main,
  fontWeight: "bold",
  minWidth: "110px",
}));

export default HeadroomTableHeaderRow;
